/**************************************************
 * Nombre:       Formulario_Pqrs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     3 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, MailOutline, PhoneAndroidOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import IngresoCheckGrupo from "../../Modulo_formularios/Componentes/IngresoCheckGrupo";

const Formulario_Pqrs = ({...props}) => {
    const [departamento, setDepartamento] = useState('')


    useEffect(() => {

        let dep = props.props.getValues('departamento')
        setDepartamento(dep)

    }, [props.props.watch('departamento')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'El Correo es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'} dato={'celula'} {...props}
                                  type={'phone'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Mensaje'} dato={'notas'} {...props}
                                  lineas={6}

                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{px: 2}} >
                    <IngresoCheckGrupo nombre={'Selccionar Tipo'} dato={'opcion'} {...props}
                                       opciones={['Peticiones', 'Quejas', 'Reclamos', 'Sugerencias']}

                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Pqrs